import qs from 'qs'

export const queryPublicationEntryPrevNextBySlug = (options: queryPrevNextOptions) => {
  const query = qs.stringify(
    {
      locale: options?.locale || 'en-US',
      sort: [`datePublished:${options?.sortDir}`, `title:${options?.sortDirSecondary}`],
      pagination: {
        page: 1,
        pageSize: 1
      },
      filters: {
        $or: [
          {
            $and: [
              {
                datePublished: {
                  $eq: options?.filterValue
                }
              },
              {
                title: {
                  [options?.filterId]: options?.filterValueSecondary
                }
              }
            ]
          },
          {
            datePublished: {
              [options?.filterId]: options?.filterValue
            }
          }
        ]
      },
      fields: queryFieldsPrevNext
    },
    {
      encodeValuesOnly: true
    }
  )

  return `publication-entries?${query}`
}
